import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
//drag and drop
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import Modal from "../../../components/modal/Modal";
import Select from "../../../components/input/Select";
//services
import { getQueues } from "../../../services/Crm/Settings/Queue/getQueues";
import { postBrokerQueue } from "../../../services/Crm/Settings/Queue/postBrokerQueue";
import { patchBrokerQueue } from "../../../services/Crm/Settings/Queue/patchBrokerQueue";
import { deleteBrokerQueue } from "../../../services/Crm/Settings/Queue/deleteBrokerQueue";
import { patchBrokerAttStatus } from "../../../services/Crm/Settings/Queue/patchBrokerAttStatus";
//assets
import profile from "../../../assets/default.jpg";
//hooks
import usePermission from "../../../hooks/usePermission";
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
//utils
import { queryClient } from "../../../utils/queryClient";
//context
import { useAppContext } from "../../../context/AppContext";

const Queue = () => {
  usePermission("235");
  const form = useForm();
  const errors = form.formState.errors;
  const { permissions } = useAppContext();
  const [columns, setColumns] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [selectedFunnel, setSelectedFunnel] = useState(null);
  const { team, isLoadingTeams, selectTeam, brokers, loadingBrokers } =
    useOptionsSelect();
  const { isLoading: isLoadingQueues } = useQuery({
    queryKey: [`queues`],
    queryFn: () => getQueues(),
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setColumns(data);
    },
    // enabled: !!permissions?.includes("101")
  });

  const { mutateAsync: postBrokerQueueFn } = useMutation({
    mutationFn: postBrokerQueue,
    onSuccess(res, variables) {
      queryClient.setQueryData(["queues"], (data) => {
        const index = data.findIndex((item) => item.id === variables.funnel_id);
        data[index].broker_queue.push({
          ...res.success,
          position: data[index].broker_queue.length + 1,
        });
        return [...data];
      });
    },
  });

  const { mutateAsync: patchBrokerAttStatusFn } = useMutation({
    mutationFn: patchBrokerAttStatus,
    onSuccess(_, variables) {
      queryClient.setQueryData(["queues"], (data) => {
        const index = data.findIndex((item) => item.id === variables.funnel_id);
        const item = data[index].broker_queue.find(
          (item) => item.id === variables.broker_id
        );
        const updatedColumns = columns.map((col) => {
          if (col.id === variables.funnel_id) {
            return {
              ...col,
              broker_queue: col.broker_queue.map((lineItem, lineIndex) => {
                if (lineItem.id === variables.broker_id) {
                  data[index].broker_queue[lineIndex].status =
                    item.status === 0 ? 1 : 0;
                  return {
                    ...lineItem,
                    status: item.status === 0 ? 1 : 0,
                  };
                }
                return lineItem;
              }),
            };
          }
          return col;
        });
        setColumns(updatedColumns);
        return [...data];
      });
    },
  });

  const { mutateAsync: deleteBrokerQueueFn } = useMutation({
    mutationFn: deleteBrokerQueue,
    onSuccess(_, variables) {
      queryClient.setQueryData(["queues"], (data) => {
        const index = data.findIndex((item) => item.id === variables.funnel_id);
        data[index].broker_queue = data[index].broker_queue.filter(
          (item) => item.id !== variables.broker_id
        );
        return [...data];
      });
    },
  });

  const onDragEnd = async (result) => {
    const notification = toast.loading("Aguarde...");
    const { source, destination } = result;

    if (!destination) return;

    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    const sourceColumn = columns.find((col) => col.name === source.droppableId);
    const destColumn = columns.find(
      (col) => col.name === destination.droppableId
    );

    const sourceItems = [...sourceColumn.broker_queue];
    const destItems =
      sourceColumn === destColumn ? sourceItems : [...destColumn.broker_queue];

    const [movedItem] = sourceItems.splice(source.index, 1);
    destItems.splice(destination.index, 0, movedItem);

    // Atualiza as posições no front
    const updatePositions = (items) => {
      return items.map((item, index) => ({ ...item, position: index }));
    };

    const updatedSourceItems = updatePositions(sourceItems);
    const updatedDestItems = updatePositions(destItems);

    const updatedColumns = columns.map((col) => {
      if (col.name === sourceColumn.name) {
        return { ...col, broker_queue: updatedSourceItems };
      }
      if (col.name === destColumn.name) {
        return { ...col, broker_queue: updatedDestItems };
      }
      return col;
    });

    const previousColumns = [...columns];

    setColumns(updatedColumns);

    const requestData = {
      funnel_id: destColumn.id,
      broker_id: movedItem.id,
      position: destination.index + 1,
    };

    try {
      await patchBrokerQueue(requestData);
      toast.update(notification, {
        render: "Corretor movido com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao mover corretor!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      setColumns(previousColumns);
    }
  };

  const items = [
    {
      template: () => (
        <Link to={`/crm/settings/line`} className="p-breadcrumb-link">
          Fila
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const addBrokerFile = async (data) => {
    const notification = toast.loading("Aguarde...");
    setLoadingButton(true);
    const sendData = {
      broker_id: data.broker_id,
      team_id: data.team_id,
      funnel_id: selectedFunnel.id,
    };
    try {
      await postBrokerQueueFn(sendData);
      toast.update(notification, {
        render: "Corretor vinculado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setLoadingButton(false);
      setVisible(false);
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao vincular corretor!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      setLoadingButton(false);
    }
  };

  const handleChangeStatus = async (broker_id, funnel_id) => {
    const notification = toast.loading("Aguarde...");
    try {
      await patchBrokerAttStatusFn({
        broker_id: broker_id,
        funnel_id: funnel_id,
      });
      toast.update(notification, {
        render: "Status alterado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao alterar status!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handleRemoveBroker = async (broker_id, funnel_id) => {
    const notification = toast.loading("Aguarde...");
    try {
      await deleteBrokerQueueFn({
        broker_id: broker_id,
        funnel_id: funnel_id,
      });
      toast.update(notification, {
        render: "Corretor removido com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao remover corretor!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-md-4">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        {/* <div className="col-md-2">
                <Button
                    rounded
                    icon="fa fa-plus"
                    label="Nova origem"
                    onClick={() => setVisibleOrigin(true)}
                    className="p-inputtext-sm me-2 m-auto w-100"
                />
            </div> */}
      </div>

      {isLoadingQueues ? (
        <Skeleton width="100%" height={450} className="mb-2" />
      ) : (
        <Panel title="Fila dos funis" mainCss="w-100">
          <DragDropContext onDragEnd={onDragEnd}>
            <div
              style={{ display: "flex", maxWidth: "100%", overflowX: "auto" }}
            >
              {columns?.map((column) => (
                <Droppable key={column.name} droppableId={column.name}>
                  {(provided) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className="funnel-card"
                      style={{
                        padding: 12,
                        minWidth: 280,
                        minHeight: 400,
                        borderRadius: "5%",
                        margin: "0 8px",
                        maxHeight: "650px",
                        overflowY: "auto",
                      }}
                    >
                      <div className="row">
                        <div className="col-md-8">
                          <h5
                            className="ps-2 text-start"
                            style={{ fontSize: "16px" }}
                          >
                            {column.name}
                          </h5>
                        </div>
                        <div className="col-md-4 gap-2 d-flex justify-content-end align-items-start">
                          <span
                            className="badge bg-secondary"
                            style={{ fontSize: "11px" }}
                          >
                            {column.broker_queue.length}
                          </span>
                          {permissions.includes("236") && (
                            <div
                              onClick={() => {
                                setSelectedFunnel(column);
                                setVisible(true);
                              }}
                              className="me-2"
                            >
                              <i
                                className="fa fa-plus card-animation"
                                style={{ fontSize: "18px" }}
                              ></i>
                            </div>
                          )}
                        </div>
                      </div>
                      {column.broker_queue.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id.toString()}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={`funnel-card-item ${
                                item.status === 0 ? "disabled" : ""
                              }`}
                              style={{
                                userSelect: "none",
                                padding: 16,
                                margin: "0 0 8px 0",
                                minHeight: "50px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                ...provided.draggableProps.style,
                              }}
                            >
                              <div className="row">
                                <div className="col-md-10 d-flex align-items-center">
                                  <span
                                    className="badge bg-secondary me-2"
                                    style={{
                                      borderRadius: "50%",
                                      paddingTop: "5px",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    {item.status === 0
                                      ? "-"
                                      : `${item.position}`}
                                  </span>
                                  <img
                                    src={
                                      item.profile_photo
                                        ? item.profile_photo.path
                                        : profile
                                    }
                                    alt="profile"
                                    className="rounded-circle me-2"
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                  <h6
                                    className="text-start"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {item.name}
                                  </h6>
                                </div>
                                <div className="col-md-2 d-flex justify-content-end align-items-center">
                                  <div className="dropdown">
                                    <i
                                      className="fa fa-ellipsis-v"
                                      id={`dropdownMenuButton-${item.id}`}
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      style={{
                                        cursor: "pointer",
                                        width: "24px",
                                        height: "24px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        pointerEvents: "auto",
                                      }}
                                    ></i>
                                    <ul
                                      className="dropdown-menu"
                                      aria-labelledby={`dropdownMenuButton-${item.id}`}
                                      style={{ pointerEvents: "auto" }}
                                    >
                                      {item.status === 0 ? (
                                        <>
                                          {permissions.includes("238") && (
                                            <li>
                                              <button
                                                className="dropdown-item"
                                                onClick={() =>
                                                  handleChangeStatus(
                                                    item.id,
                                                    column.id
                                                  )
                                                }
                                              >
                                                <i className="fa fa-check me-2"></i>
                                                Ativar
                                              </button>
                                            </li>
                                          )}
                                          {permissions.includes("239") && (
                                            <li>
                                              <button
                                                className="dropdown-item"
                                                onClick={() =>
                                                  handleRemoveBroker(
                                                    item.id,
                                                    column.id
                                                  )
                                                }
                                              >
                                                <i className="fa fa-trash me-2"></i>
                                                Remover
                                              </button>
                                            </li>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {permissions.includes("238") && (
                                            <li>
                                              <button
                                                className="dropdown-item"
                                                onClick={() =>
                                                  handleChangeStatus(
                                                    item.id,
                                                    column.id
                                                  )
                                                }
                                              >
                                                <i className="fa fa-ban me-2"></i>
                                                Inativar
                                              </button>
                                            </li>
                                          )}
                                          {permissions.includes("239") && (
                                            <li>
                                              <button
                                                className="dropdown-item"
                                                onClick={() =>
                                                  handleRemoveBroker(
                                                    item.id,
                                                    column.id
                                                  )
                                                }
                                              >
                                                <i className="fa fa-trash me-2"></i>
                                                Remover
                                              </button>
                                            </li>
                                          )}
                                        </>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              ))}
            </div>
          </DragDropContext>
        </Panel>
      )}

      <Modal
        dynamicTitle="Adicionar Vendedor"
        position={"top-right"}
        visible={visible}
        dynamicWidth={window.innerWidth <= 992 ? "80vw" : "25vw"}
        onHide={() => setVisible(false)}
      >
        <form onSubmit={form.handleSubmit(addBrokerFile)}>
          <div className="row">
            <div className="col-md-12">
              <Select
                name="team_id"
                label={isLoadingTeams ? "Carregando..." : `Time`}
                control={form.control}
                errors={errors}
                onChange={(e) => selectTeam(e)}
                disabled={isLoadingTeams ? true : false}
                options={team}
              />
            </div>
            <div className="col-md-12">
              <Select
                name="broker_id"
                label={loadingBrokers ? "Carregando..." : "Corretor"}
                control={form.control}
                options={brokers}
                disabled={loadingBrokers ? true : false}
                errors={errors}
              />
            </div>
            <div className="row justify-content-end">
              <div className="col-md-6 pt-3 justify-content-end d-flex">
                <Button
                  rounded
                  type="submit"
                  label="Vincular"
                  iconPos="right"
                  loading={loadingButton}
                  className="p-inputtext-sm w-100"
                  icon="fa-solid fa-check"
                />
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default Queue;
